import { Concrete } from '../../CIMSModule/instances'
import { Permission } from '../../permission'
import { RoleTemplateItem } from '../RoleTemplateItem'

export const ConcreteAdmin = new RoleTemplateItem({
  id: '2e67655d-e222-453f-8e8e-15a54357be48',
  name: 'Concrete Admin',
  description:
    'Gives users access to all permissions within the Concrete workflow',
  module: Concrete,
  permissionItems: Permission.findByModule(Concrete),
})

export const LabConcrete = new RoleTemplateItem({
  id: '763ed14d-5747-41c8-a04d-7136aaa21e4f',
  name: 'Lab Concrete',
  description:
    'Gives users access to enter concrete data for the Concrete workflow',
  module: Concrete,
  permissionItems: [
    Permission.ViewConcreteTestSet,
    Permission.EditConcreteNotification,
    Permission.EditConcreteBreakData,
    Permission.EditLimitedTestingLab,
    Permission.CreateLabTech,
    Permission.EditLabTech,
  ],
})

export type ConcreteRoleTemplateItem = typeof ConcreteAdmin | typeof LabConcrete
